import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageToRightComponent } from './image-to-right.component';



@NgModule({
  declarations: [
    ImageToRightComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ImageToRightComponent
  ]
})
export class ImageToRightModule { }
